import { invalidateCache } from 'api/urql/helpers/mutation';

export const createCustomJobReport = (results, args, cache, info) => {
  invalidateCache('paginatedCustomJobReports')(results, args, cache, info);
};
